(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["btb-signup-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      const dialog = document.getElementById('BtbSignupDialog');
      if (!dialog || dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
      dialog.dataset.initialized = 'true';
      let timer;
      const key = 'btb-store-signup20-dismissed';
      const get = (name) => { try { return localStorage.getItem(name); } catch { return null; } };
      const set = (name, value) => { try { localStorage.setItem(name, value); } catch {} };
      const open = () => { clearTimeout(timer); if (!dialog.open) dialog.showModal(); };
      const dismiss = () => { clearTimeout(timer); set(key, String(Date.now())); dialog.close(); };
      dialog.querySelectorAll('[data-btb-close]').forEach(button => button.addEventListener('click', dismiss));
      dialog.addEventListener('cancel', () => { set(key, String(Date.now())); clearTimeout(timer); });
      dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dismiss(); } });
      document.querySelectorAll('[data-btb-offer]').forEach(button => button.addEventListener('click', open));
      document.querySelectorAll('form[action*="/cart/add"]').forEach(form => form.addEventListener('submit', () => clearTimeout(timer)));
      if (dialog.querySelector('[data-btb-errors]')) { open(); return; }
      if (dialog.querySelector('[data-btb-success]')) {
        const params = new URLSearchParams(location.search);
        set('btb-store-signup20-complete', 'true');
        if (dialog.querySelector('[data-btb-posted]') || params.has('customer_posted') || location.hash.includes('BtbSignupForm')) open();
        return;
      }
      if (get('btb-store-signup20-complete')) return;
      const dismissed = Number(get(key) || 0);
      if (!/(^|\/)(products|cart)(\/|$)/.test(location.pathname) && Date.now() - dismissed > 7 * 24 * 60 * 60 * 1000) timer = setTimeout(() => { if (!document.querySelector('dialog[open]') && !document.activeElement?.matches('input,textarea,select')) open(); }, 8000);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
